import React from "react"
import { Link } from "gatsby"
const BtnVer = ({ name, to, type }) => {
  return (
    <>
      {to === undefined ? (
        <div className="btnVer-container">
          <div className="circle plus"></div>
          <div className="btn-name">{name}</div>
        </div>
      ) : type === true ? (
        <a href={to}>
          <div className="btnVer-container">
            <div className="circle plus"></div>
            <div className="btn-name">{name}</div>
          </div>
        </a>
      ) : (
        <Link to={to}>
          <div className="btnVer-container">
            <div className="circle plus"></div>
            <div className="btn-name">{name}</div>
          </div>
        </Link>
      )}
    </>
  )
}

export default BtnVer
